import * as THREE from 'three'
import { getelementSetting } from './setting'
import trafficlight_png from '@/components/images/trafficlight.png'
import { createSpriteText_map } from '@/utils/labeltext.js'
import { createLine, createMesh } from './map'
import { disposeO3D } from "./threejsHelper"
import { store } from '@/store/index'
import { createMeshFromLine } from '@/utils/threejsHelper'


let elementSetting = null;
let scene_global = null;
let mapLabelMap = new Map()
let mapLabelMap_visible = true


//全图 
export const renderMap_all = (mapData, position, scene, mapLabelMap_in, mapLabelMap_visible_in, elementSetting_in) => {
    if (!mapData) return
    scene_global = scene;
    mapLabelMap = mapLabelMap_in
    mapLabelMap_visible = mapLabelMap_visible_in
    elementSetting = elementSetting_in
    load_map_line_all(mapData.stopLineList, 'stop_line', position) //已完成 1，停止线
    load_map_line_all(mapData.boundaryList, 'boundary', position) //有几个类型没有特别设计 2 ，边界
    load_map_line_all_layer_num(mapData.laneList?.filter(e => !e.virtualType), 'lane', position) //已完成   3，行车线
    load_map_line_all(mapData.laneList?.filter(e => e.virtualType === 1), 'lane_virtual', position) //INTERSECTION_MOCKED 路口虚拟车道
    load_map_line_all(mapData.laneList?.filter(e => e.virtualType === 2), 'lane_road_mocked', position) //ROAD_MOCKED 道路虚拟车道
    load_map_mesh_all(mapData.clearZoneList, 'clear_zone', position) //4，禁停区
    load_map_mesh_all(mapData.crossWalkList, 'cross_walk', position) //已完成，,5，人行横道
    load_map_mesh_all(mapData.freeAreaList, 'free_area', position) //6，自由停车区，
    load_map_line_all(mapData.gateList, 'gate', position) //未完成，缺真实数据,7，小区门、栏杆，
    load_map_line_all(mapData.intersectionList, 'intersection', position) //已完成,8，路口  //todo 也可以描绘成面
    load_map_mesh_all(mapData.parkingList, 'parking', position) //9，停车位，
    load_map_mesh_all(mapData.pillarList, 'pillar', position) //已完成，10，石墩
    load_map_mesh_all(mapData.prohibitedAreaList, 'prohibited_area', position) //已完成 11，禁行区
    load_map_mesh_all(mapData.speedBumpList, 'speed_bump', position) //已完成,13，减速带，
    load_map_mesh_all(mapData.safetyIslandList, 'safety_island', position) //缺真实数据,12，安全岛，
    load_map_mesh_all(mapData.multiLayerAreaList, 'multiLayerArea', position) //19，多楼层区域
    load_map_trafficLight_all(mapData.trafficLightList, 'traffic_light', position) //14红绿灯
}
const trafficLightLabel = new THREE.Group()
const load_map_trafficLight_all = (lineData = [], lineType, center) => {
    if (lineData && lineData.length > 0) {
        const setting = getMapSettingByType(lineType)
        lineData.forEach((e) => {
            if (!setting.mapObject.has(e.id)) {
                var pos1 = new THREE.Vector3(center.x, center.y, 0)
                var pos2 = new THREE.Vector3(e.position.x, e.position.y, 0)
                var distance = pos1.distanceTo(pos2)
                if (distance < 100) {
                    getTrafficLightTexture().then((material) => {
                        let z_tra = Math.min(Math.max(1, e.position.z - center.z), 10);
                        const geometry = new THREE.BoxGeometry(2, 1, 1)
                        const cube = new THREE.Mesh(geometry, material)
                        cube.position.set(e.position.x, e.position.y, z_tra)
                        cube.rotation.set(0, 0, Math.PI + (e.angle / 180) * Math.PI)
                        if (!setting.mapObject.has(e.id)) {
                            createLable_trafficLight(e).then((elementLabel) => {
                                cube.add(elementLabel)
                            })
                            let labelGroup = createSpriteText_map([e.id], 60);
                            if (Math.abs(e.angle) < 45 || Math.abs(e.angle) > 135) {
                                labelGroup.position.set(e.position.x + e.angle / 180, e.position.y, z_tra + 1)
                            } else {
                                labelGroup.position.set(e.position.x, e.position.y + e.angle / 180, z_tra + 1)
                            }
                            labelGroup.up = new THREE.Vector3(0, 0, 1)
                            labelGroup.rotation.x = Math.PI / 2
                            isShowTrafficLabel(false)
                            trafficLightLabel.add(labelGroup)
                            setting.group.add(trafficLightLabel)
                            setting.group.add(cube)
                            setting.mapObject.set(e.id, cube)
                        } else {
                            cube.geometry.dispose()
                        }
                    })
                }
            }
        })
    }
}
export const isShowTrafficLabel = (visible) => {
    trafficLightLabel.visible = visible
}
const load_map_mesh_all = (data, type, center) => {
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(type)
        data?.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                const mesh = createMesh({
                    name: type,
                    element: el
                })
                if (mesh) {
                    if (!setting.mapObject.has(el.id)) {
                        createLable(el).then((elementLabel) => {
                            mesh.add(elementLabel)
                        })
                        mesh.positionEX = el.pointList[0]
                        mesh.renderOrder = -20
                        setting.group.add(mesh)
                        setting.mapObject.set(el.id, mesh)
                    } else {
                        mesh.geometry.dispose()
                    }
                }
            }
        })
    })
}
/**
* 加载线性元素
*/
const load_map_line_all = (lineData, lineType, center) => {
    if (!lineData) return
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(lineType)
        lineData.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                const line = createLine({
                    name: lineType,
                    type: el.type,
                    element: el
                })
                if (line) {
                    if (!setting.mapObject.has(el.id)) {
                        createLable(el).then((elementLabel) => {
                            line.add(elementLabel)
                        })
                        setting.group.add(line)
                        setting.mapObject.set(el.id, line)
                    } else {
                        line.geometry.dispose()
                    }
                }
            }
        })
    })
}
/**
* 加载线性元素 带楼层的lane 单独处理
*/
const load_map_line_all_layer_num = (lineData, lineType, center) => {
    if (!lineData) return
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(lineType)
        lineData.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                let distance = el.pointList.find(p => (Math.abs(p.x - center.x) < 100) && (Math.abs(p.y - center.y) < 100))
                if (distance) {
                    const line = createLine({
                        name: lineType,
                        type: el.type,
                        element: el
                    })
                    if (line) {
                        if (!setting.mapObject.has(el.id)) {
                            createLable(el).then((elementLabel) => {
                                line.add(elementLabel)
                            })
                            setting.group.add(line)
                            setting.mapObject.set(el.id, line)
                        } else {
                            line.geometry.dispose()
                        }
                    }
                }
            }
        })
    })
}

/**
 * 获取不同类型的地图元素配置
 */
export const getMapSettingByType = (typeName) => {
    let setting = elementSetting.mapSetting[typeName]
    if (!setting) return
    if (!setting.group) {
        setting.group = new THREE.Group()
        setting.group.visible = setting.visible
        setting.z = setting.z || 0
        setting.group.position.set(0, 0, setting.z)
        scene_global.add(setting.group)
    }
    if (!setting.mapObject) {
        setting.mapObject = new Map()
    }
    return setting
}

let promise_TrafficLightTexture = null
const getTrafficLightTexture = () => {
    if (promise_TrafficLightTexture) return promise_TrafficLightTexture
    return new Promise((resolve, reject) => {
        const loader = new THREE.TextureLoader()
        loader.load(
            // 资源URL
            trafficlight_png,
            // onLoad回调
            (texture) => {
                // in this example we create the material when the texture is loaded
                const material = new THREE.MeshBasicMaterial({
                    map: texture
                    // side: THREE.DoubleSide
                })
                resolve(material)
            },
            // 目前暂不支持onProgress的回调
            undefined,
            // onError回调
            function (err) {
                console.error(err)
                reject(err)
            }
        )
    })
}


const createLable = (mapElement) => {
    let label_size = Number(store.state.wsModule.label_size || 5) * 6;
    return new Promise((resolve, reject) => {
        if (mapLabelMap.has(mapElement.id)) {
            let element = mapLabelMap.get(mapElement.id)
            element.visible = mapLabelMap_visible
            resolve(element)
        } else {
            let center = getCenterFromArray(mapElement.pointList)
            let element = createSpriteText_map([mapElement.id], label_size);
            element.position.set(center.x, center.y, center.z)
            element.up = new THREE.Vector3(0, 0, 1)
            if (!mapLabelMap.has(mapElement.id)) {
                mapLabelMap.set(mapElement.id, element)
                element.visible = mapLabelMap_visible
                resolve(element)
            } else {
                let element = mapLabelMap.get(mapElement.id)
                element.visible = mapLabelMap_visible
                resolve(element)
            }
        }
    })
}

const createLable_trafficLight = (mapElement) => {
    let label_size = Number(store.state.wsModule.label_size || 5) * 6;
    return new Promise((resolve, reject) => {
        if (mapLabelMap.has(mapElement.id)) {
            let element = mapLabelMap.get(mapElement.id)
            element.visible = mapLabelMap_visible
            resolve(element)
        } else {
            let element = createSpriteText_map([mapElement.id], label_size);
            element.position.set(0, 0, 1)
            element.up = new THREE.Vector3(0, 0, 1)
            if (!mapLabelMap.has(mapElement.id)) {
                mapLabelMap.set(mapElement.id, element)
                element.visible = mapLabelMap_visible
                resolve(element)
            } else {
                let element = mapLabelMap.get(mapElement.id)
                element.visible = mapLabelMap_visible
                resolve(element)
            }
        }
    })
}
const getCenterFromArray = (polygonList = []) => {
    if (polygonList.length > 0) {
        let index = Math.floor(polygonList.length / 2);
        let center = {
            x: polygonList[index].x,
            y: polygonList[index].y
        }
        return center
    } else {
        return { x: 0, y: 0 }
    }
}

export const setMapVisible = (e) => {
    if (elementSetting) {
        for (let item in elementSetting.mapSetting) {
            elementSetting.mapSetting[item].visible = e.includes(item)
            if (elementSetting.mapSetting[item].group)
                elementSetting.mapSetting[item].group.visible =
                    elementSetting.mapSetting[item].visible
        }
    }
}
export const setMapVisible_all = (isVisble) => {
    if (elementSetting) {
        for (let item in elementSetting.mapSetting) {
            elementSetting.mapSetting[item].visible = isVisble
            if (elementSetting.mapSetting[item].group)
                elementSetting.mapSetting[item].group.visible =
                    elementSetting.mapSetting[item].visible
        }
    }
}

export const clearMapGroup = () => {
    if (!elementSetting) {
        return
    }
    for (let attributeName in elementSetting.mapSetting) {
        let element = elementSetting.mapSetting[attributeName]
        if (element) {
            if (element.group) {
                disposeO3D(element.group)
                element.group = null
            }
            if (element.mapObject) {
                element.mapObject.clear()
            }
        }
    }
}

/**
 * 裁剪全图，从position位置，裁剪出一个300范围的小图；
 * @param {*} mapData 
 * @param {*} position 
 * @returns 
 */
export const filterMapAll = (mapData, position) => {
    if (!mapData) {
        return;
    }
    // let mapData = mapDataObject.vct
    let mapData_filter = {};
    mapData_filter.stopLineList = filter_map_line_all(mapData.stopLineList, position) //已完成 1，停止线
    mapData_filter.boundaryList = filter_map_line_all(mapData.boundaryList, position) //有几个类型没有特别设计 2 ，边界
    mapData_filter.laneList = filter_map_line_all(mapData.laneList, position) //已完成   3，行车线
    mapData_filter.clearZoneList = filter_map_line_all(mapData.clearZoneList, position) //4，禁停区
    mapData_filter.crossWalkList = filter_map_line_all(mapData.crossWalkList, position) //已完成，,5，人行横道
    mapData_filter.freeAreaList = filter_map_line_all(mapData.freeAreaList, position) //6，自由停车区，
    mapData_filter.gateList = filter_map_line_all(mapData.gateList, position) //未完成，缺真实数据,7，小区门、栏杆，
    mapData_filter.intersectionList = filter_map_line_all(mapData.intersectionList, position) //已完成,8，路口  //todo 也可以描绘成面
    mapData_filter.parkingList = filter_map_line_all(mapData.parkingList, position) //9，停车位，
    mapData_filter.pillarList = filter_map_line_all(mapData.pillarList, position) //已完成，10，石墩
    mapData_filter.prohibitedAreaList = filter_map_line_all(mapData.prohibitedAreaList, position) //已完成 11，禁行区
    mapData_filter.speedBumpList = filter_map_line_all(mapData.speedBumpList, position) //已完成,13，减速带，
    mapData_filter.safetyIslandList = filter_map_line_all(mapData.safetyIslandList, position) //缺真实数据,12，安全岛
    mapData_filter.multiLayerAreaList = filter_map_line_all(mapData.multiLayerAreaList, position) //19，多楼层区域
    mapData_filter.trafficLightList = filter_map_trafficLightList(mapData.trafficLightList, position) //缺真实数据,12，安全岛)   
    return mapData_filter;
    // if (!mapDataObject || !mapDataObject.vct) {
    //     return;
    // }
    // if (mapDataObject.type == 1) {
    //     //整图
    //     let mapData = mapDataObject.vct
    //     let mapData_filter = {};
    //     mapData_filter.stopLineList = filter_map_line_all(mapData.stopLineList, position) //已完成 1，停止线
    //     mapData_filter.boundaryList = filter_map_line_all(mapData.boundaryList, position) //有几个类型没有特别设计 2 ，边界
    //     mapData_filter.laneList = filter_map_line_all(mapData.laneList, position) //已完成   3，行车线
    //     mapData_filter.clearZoneList = filter_map_line_all(mapData.clearZoneList, position) //4，禁停区
    //     mapData_filter.crossWalkList = filter_map_line_all(mapData.crossWalkList, position) //已完成，,5，人行横道
    //     mapData_filter.freeAreaList = filter_map_line_all(mapData.freeAreaList, position) //6，自由停车区，
    //     mapData_filter.gateList = filter_map_line_all(mapData.gateList, position) //未完成，缺真实数据,7，小区门、栏杆，
    //     mapData_filter.intersectionList = filter_map_line_all(mapData.intersectionList, position) //已完成,8，路口  //todo 也可以描绘成面
    //     mapData_filter.parkingList = filter_map_line_all(mapData.parkingList, position) //9，停车位，
    //     mapData_filter.pillarList = filter_map_line_all(mapData.pillarList, position) //已完成，10，石墩
    //     mapData_filter.prohibitedAreaList = filter_map_line_all(mapData.prohibitedAreaList, position) //已完成 11，禁行区
    //     mapData_filter.speedBumpList = filter_map_line_all(mapData.speedBumpList, position) //已完成,13，减速带，
    //     mapData_filter.safetyIslandList = filter_map_line_all(mapData.safetyIslandList, position) //缺真实数据,12，安全岛
    //     mapData_filter.trafficLightList = filter_map_trafficLightList(mapData.trafficLightList, position) //缺真实数据,12，安全岛)   
    //     return mapData_filter;
    // }else{
    //     //分幅
    // }

}
const filter_map_line_all = (alldata, origin) => {
    return alldata?.filter(el => {
        if (el.pointList.length <= 0) {
            return false;
        }
        let index = Math.floor(el.pointList.length / 2);
        return Math.abs(el.pointList[index].x - origin.x) < 300 && (Math.abs(el.pointList[index].y - origin.y) < 300)
    })
}
const filter_map_trafficLightList = (alldata, origin) => {
    return alldata?.filter(e => (Math.abs(e.position.x - origin.x) < 300) && (Math.abs(e.position.y - origin.y) < 300));
}

//delete
export const renderMap = (mapData, scene, mapLabelMap_in, mapLabelMap_visible_in, elementSetting_in) => {
    //已完成
    scene_global = scene;
    mapLabelMap = mapLabelMap_in
    mapLabelMap_visible = mapLabelMap_visible_in
    elementSetting = elementSetting_in
    load_map_line(mapData.stopLineList, 'stop_line') //已完成 1，停止线
    load_map_line(mapData.boundaryList, 'boundary') //有几个类型没有特别设计 2 ，边界
    load_map_line(mapData.laneList, 'lane') //已完成   3，行车线
    load_map_mesh(mapData.clearZoneList, 'clear_zone') //4，禁停区
    load_map_mesh(mapData.crossWalkList, 'cross_walk') //已完成，,5，人行横道
    load_map_mesh(mapData.freeAreaList, 'free_area') //6，自由停车区，
    load_map_line(mapData.gateList, 'gate') //未完成，缺真实数据,7，小区门、栏杆，
    load_map_line(mapData.intersectionList, 'intersection') //已完成,8，路口  //todo 也可以描绘成面
    load_map_mesh(mapData.parkingList, 'parking') //9，停车位，
    load_map_mesh(mapData.pillarList, 'pillar') //已完成，10，石墩
    load_map_mesh(mapData.prohibitedAreaList, 'prohibited_area') //已完成 11，禁行区
    load_map_mesh(mapData.speedBumpList, 'speed_bump') //已完成,13，减速带，
    load_map_mesh(mapData.safetyIslandList, 'safety_island') //缺真实数据,12，安全岛，
    load_map_trafficLight(mapData.trafficLightList, 'traffic_light') //红绿灯
}
/**
* 加载线性元素
*/
const load_map_line = (lineData, lineType) => {
    if (!lineData) return
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(lineType)
        for (let [key, value] of setting.mapObject) {
            //删除的
            let ele = lineData.find((element) => element.id == key)
            if (!ele) {
                var pos1 = new THREE.Vector3(origin.x, origin.y, 0)
                var pos2 = new THREE.Vector3(value.positionEX.x, value.positionEX.y, 0)
                var distance = pos1.distanceTo(pos2)
                if (distance > 200) {
                    setting.group.remove(value)
                    value.geometry.dispose()
                    setting.mapObject.delete(key)
                }
            }
        }
        lineData.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                const line = createLine({
                    name: lineType,
                    type: el.type,
                    element: el
                })
                if (line) {
                    if (!setting.mapObject.has(el.id)) {
                        createLable(el).then((elementLabel) => {
                            line.add(elementLabel)
                        })
                        setting.group.add(line)
                        setting.mapObject.set(el.id, line)
                    }
                }
            }
        })
    })
}
/**
 * 加载红绿灯
 */
const load_map_trafficLight = (lineData = [], lineType) => {
    if (lineData && lineData.length > 0) {
        const setting = getMapSettingByType(lineType)
        lineData.forEach((e) => {
            if (!setting.mapObject.has(e.id)) {
                getTrafficLightTexture().then((material) => {
                    const geometry = new THREE.BoxGeometry(2, 0.1, 1)
                    const cube = new THREE.Mesh(geometry, material)
                    cube.position.set(e.position.x, e.position.y, e.position.z)
                    cube.rotation.set(0, 0, Math.PI + (e.angle / 180) * Math.PI)
                    if (!setting.mapObject.has(e.id)) {
                        setting.mapObject.set(e.id, cube)
                        setting.group.add(cube)
                    }
                })
            }
        })
    }
}

/**
 * 加载面元素
 */
const load_map_mesh = (data, type) => {
    Promise.resolve().then(() => {
        const setting = getMapSettingByType(type)
        for (let [key, value] of setting.mapObject) {
            //删除的
            let ele = data.find((element) => element.id == key)
            if (!ele) {
                var pos1 = new THREE.Vector3(origin.x, origin.y, 0)
                var pos2 = new THREE.Vector3(value.positionEX.x, value.positionEX.y, 0)
                var distance = pos1.distanceTo(pos2)
                if (distance > 200) {
                    setting.group.remove(value)
                    value.geometry.dispose()
                    setting.mapObject.delete(key)
                }
            }
        }
        data.forEach((el) => {
            if (!setting.mapObject.has(el.id)) {
                const mesh = createMesh({
                    name: type,
                    element: el
                })
                if (mesh) {
                    if (!setting.mapObject.has(el.id)) {
                        createLable(el).then((elementLabel) => {
                            mesh.add(elementLabel)
                        })
                        mesh.positionEX = el.pointList[0]
                        mesh.renderOrder = -20
                        setting.group.add(mesh)
                        setting.mapObject.set(el.id, mesh)
                    }
                }
            }
        })
    })
}

let active_map_ele_side = null;
let active_map_ele_material = null;
export const active_map_ele = () => {
    let mapSearchItem = store.state.wsModule.mapSearchItem;
    if (!mapSearchItem) {
        if (active_map_ele_side) {
            disposeO3D(active_map_ele_side);
        }
        return;
    } else {
        let new_active_map_ele_side = active_map_element(mapSearchItem.type, JSON.parse(mapSearchItem.data))
        if (new_active_map_ele_side) {
            if (active_map_ele_side) {
                disposeO3D(active_map_ele_side);
            }
            active_map_ele_side = new_active_map_ele_side;
        }
        return new_active_map_ele_side
    }
}

const active_map_element = (type, data) => {
    let result = null;
    switch (type) {
        case "laneList":
        case "stopLineList":
        case "intersectionList":
        case "boundaryList":
        case "freeAreaList":
        case "crossWalkList":
        case "crossWalkList":
        case "safetyIslandList":
            result = active_map_line(data)
            break;
        case "trafficLightList":
            result = active_map_trafficLight(data);
            break;
        default:
            console.log("暂不支持");
    }
    return result;
}
const active_map_line = (data) => {
    //lane   StopLine  pointList
    //Intersection pointList 闭合的
    let heartShape = new THREE.Shape()
    let pointsList = createMeshFromLine(data.pointList, 0.3)
    pointsList.forEach((e, index) => {
        if (index == 0) {
            heartShape.moveTo(e.x, e.y)
        } else {
            heartShape.lineTo(e.x, e.y)
        }
    })

    const geometry_shape = new THREE.ShapeGeometry(heartShape)
    if (!active_map_ele_material) {
        active_map_ele_material = new THREE.MeshBasicMaterial({
            color: 0xef4136,
            side: THREE.DoubleSide
        })
    }
    const mesh = new THREE.Mesh(geometry_shape, active_map_ele_material)
    mesh.position.set(0, 0, 0.011)
    mesh.renderOrder = -10
    mesh.center = getCenter(data.pointList);
    if (scene_global) {
        scene_global.add(mesh)
    }
    return mesh;
}
const active_map_trafficLight = (data) => {
    const geometry = new THREE.BoxGeometry(2, 0.3, 1)
    if (!active_map_ele_material) {
        active_map_ele_material = new THREE.MeshBasicMaterial({
            color: 0xf173ac,
            side: THREE.DoubleSide
        })
    }
    const cube = new THREE.Mesh(geometry, active_map_ele_material)
    cube.position.set(data.position.x, data.position.y, data.position.z)
    cube.rotation.set(0, 0, Math.PI + (data.angle / 180) * Math.PI)
    cube.center = data.position;
    if (scene_global) {
        scene_global.add(cube)
    }
    return cube;
}
const getCenter = (pointList = []) => {
    if (!pointList || pointList.length == 0) {
        return null;
    }
    let sum = pointList.reduce((pre, cur) => {
        return { x: pre.x + cur.x, y: pre.y + cur.y }
    }, { x: 0, y: 0 })
    let center = {
        x: sum.x / pointList.length,
        y: sum.y / pointList.length
    }
    return center;
}

